var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_2031",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_2031",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACIklEQVR4nO3cvW6TMRjF8eMq7UAGyAa9LzKAChsgMYHEx4RewVipC1xBEQztyC0h1nRJIzVSzcCIqijx85w47f83v7WtI9fNe1JZAgAAAIBOlW0vQJL0+OxgMqpfVMqRpEdBo/6RyvfZsn7S+fQqaMyNjba9AEma7JfPkt4HD3so1Q+T/aKZ9DF47LXtbXsB/9RnaUOX+jxt7DWkHx2HL37dW8wvj1XLU0n3s+db04VUfoyX9d3v8+kic6L0o2MxvzxRLS+z59nQA6m+nh/UkaRXmRPlHh3DsKda8o6FKLUcaRhSs+jkjL79snf0tUo9TZ0jRDnVMFxnzpC+o8dX5Y2kb5IusufawEylfh0v69ttLwQAACBGU9fReY8RJaQPaeo6Ou8xooT0IZu/sOxKjxGlsQ+h6zBp2dE70mNEaetDmnZ05z1GlJA+JOwblsmTsxo1Vk9mP6chGXFGmxC0Sfp3hjf96t101PT2fBR2tAlBmxC0CUGbELQJLywr8MKyYwjahKBNCNqEoE3oOlY8H4UdbULQJgRtQtAmBG1C17ECXceOIWgTgjYhaBOCNqHrWPF8FHa0CUGbELQJQZsQtEnbe3zO7V69CbltrOnjXdLtXr0JuW2s8ehIvN2rN423jbWe0bf1uPhf1cOWH+ePoQlBm+xM17Euuo47iqBNCNqEoE0I2iT9U0dv/++xrfWwo00I2oSgTQjahKABAAAA4K77C+PmwPAezwjgAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.047295bcfa3a6f318c68b8fa7dede0a4.svg";
export { ForwardRef as ReactComponent };